<script setup lang="ts">
import { computed } from 'vue';

import useFileAiReviewsSearch from './Search/useFileAiReviewsSearch';
import FileAiReviewsBaseTable from './base.vue';

import type { FileAiReviewFragmentFragment, FileFragmentFragment } from '@/graphql/generated/graphql';
import NoDataUrql from '@/ui/NoDataUrql/NoDataUrql.vue';
import Skeletons from '@/ui/Skeletons.vue';

interface Props {
  file: FileFragmentFragment;
  getLink?: (data: FileAiReviewFragmentFragment) => string;
  onClick?: (data: FileAiReviewFragmentFragment) => void;
  onSelect?: (data: FileAiReviewFragmentFragment) => void;
  setUrl?: boolean;
}

const props = defineProps<Props>();
const search = useFileAiReviewsSearch(computed(() => props.file.id), props.setUrl);
</script>
<template>
  <NoDataUrql
    v-if="!search.data.value?.data"
    :error="search.error.value"
    :fetching="search.fetching.value"
  >
    <Skeletons :total="10" :avatar="false" :paragraph="false" />
  </NoDataUrql>
  <FileAiReviewsBaseTable
    v-if="search.data.value?.data"
    :pagination="search.data.value.paginatorInfo"
    :data-source="search.data.value.data"
    :loading="search.fetching.value"
    :get-link="getLink"
    :on-click="onClick"
    :on-select="onSelect"
    :refetch="search.refetch"
    :query="search.query.value"
    :set-query="search.setQuery"
    :file="file"
  >
    <template #top_pag_left>
      <FileAiReviewFormCreateModal
        :file="file"
        :on-refetch="() => { search.refetch(); }"
      />
    </template>
  </FileAiReviewsBaseTable>
</template>
